/* No customer data leaves the storefront until the shopper submits the form. */
if (!customElements.get('rt-restock')) {
  customElements.define('rt-restock', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-restock-status]');
      this.button = this.form?.querySelector('button[type="submit"]');
      if (!this.form || !this.status || !this.button) return;
      this.abort = new AbortController();
      this.form.addEventListener('submit', (event) => this.submit(event), { signal: this.abort.signal });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) === this.dataset.section) this.select(data.variant?.id);
        });
      }
      this.select(this.dataset.variant);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.lookup?.abort();
      this.unsubscribe?.();
    }
    async select(id) {
      this.lookup?.abort();
      this.lookup = new AbortController();
      this.variant = id ? String(id) : '';
      this.hidden = true;
      this.status.textContent = '';
      this.form.hidden = false;
      this.button.disabled = false;
      this.querySelector('details').open = false;
      if (!this.variant || this.dataset.country !== 'GB') return;
      const current = this.variant;
      try {
        const url = new URL(`${this.dataset.endpoint}/status`, location.origin);
        url.searchParams.set('variant', current);
        url.searchParams.set('country', 'GB');
        const response = await fetch(url, { signal: this.lookup.signal, headers: { Accept: 'application/json' } });
        if (!response.ok || !response.headers.get('content-type')?.includes('application/json')) return;
        const result = await response.json();
        if (this.variant === current) this.hidden = result.eligible !== true;
      } catch (error) {
        // Existing available-gifts and human-help links remain if the app is unavailable.
        if (error.name !== 'AbortError') this.hidden = true;
      }
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || !this.form.reportValidity()) return;
      const variant = this.variant;
      const data = new FormData(this.form);
      this.busy = true;
      this.button.disabled = true;
      this.status.textContent = 'Saving your request…';
      try {
        const response = await fetch(`${this.dataset.endpoint}/request`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ email: data.get('email'), variant, country: 'GB', consent: data.get('consent') === 'on', website: data.get('website') || '' }),
          signal: this.abort.signal
        });
        if (!response.headers.get('content-type')?.includes('application/json')) throw new Error('Please try again shortly, or contact the shop.');
        const result = await response.json();
        if (this.variant !== variant) return;
        if (!response.ok || result.ok !== true) throw new Error(result.error || 'Please try again shortly, or contact the shop.');
        this.status.textContent = result.message || 'Check your inbox to confirm your request.';
        this.form.reset();
        this.form.hidden = true;
      } catch (error) {
        if (this.variant === variant && error.name !== 'AbortError') this.status.textContent = error.message === 'Failed to fetch' ? 'We couldn’t save your request. Please try again shortly, or contact the shop.' : error.message;
      } finally {
        this.busy = false;
        this.button.disabled = false;
      }
    }
  });
}
